const USD = 'USD';

export const BookingCurrency = {
  USD,
};
